/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// 满赠活动，最好放后端不要放前端
/* (() => {
  // M12
  const GIFT_A_ID = 44624748871930;
  // TKP13
  const GIFT_B_ID = 44624739041530;

  const cartUrl = window.themeVariables.routes.cartUrl;
  const cartUrlAjax = `${cartUrl}.js`;
  const cartAddUrlAjax = `${window.themeVariables.routes.cartAddUrl}.js`;
  const cartChangeUrlAjax = `${window.themeVariables.routes.cartChangeUrl}.js`;

  async function fetchJSON(url, options = {}) {
    try {
      const res = await fetch(url, options);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      return res.json();

    } catch (err) {
      console.error(`❌ [fetchJSON] Error fetching ${url}:`, err);
      return null;
    }
  }

  function getUrl(url) {
    return fetchJSON(url, {
      method: 'GET',
      cache: 'reload',
      credentials: "same-origin",
    })
  }

  function postUrl(url, data) {
    return fetchJSON(url, {
      credentials: "same-origin",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }

  // 获取购物车信息
  async function fetchCart() {
    console.log('fetchCart')
    const res = await getUrl(cartUrlAjax);
    if (res) {
      GiftManager.checkAndApplyGift(res);
    };
  }

  const GiftManager = {
    isLocked: false,
    lastTotal: null,

    async checkAndApplyGift(cart) {
      if (this.isLocked) return;
      this.isLocked = true;
      console.log({ total: cart.total_price, lastTotal: this.lastTotal })

      console.log('checkAndApplyGift', Date.now())

      try {
        // Note： main-cart页面执行的是页面刷新每次刷新后this.lastTotal都是undefined,除非改成局部刷新
        // if (cart.total_price === this.lastTotal) {
        //   return; // 状态没变，跳过
        // }
        // this.lastTotal = cart.total_price;
        // 满赠逻辑
        const cartTotal = cart.total_price / 100; // 转换为元
        const giftAItem = cart.items.find(item => item.variant_id === GIFT_A_ID);
        const giftBItem = cart.items.find(item => item.variant_id === GIFT_B_ID);

        // 修正赠品数量（限制每种赠品最多只能 1 个）
        if (giftAItem && giftAItem.quantity > 1) {
          await updateGiftQuantity(giftAItem.key, 1);
        }
        if (giftBItem && giftBItem.quantity > 1) {
          await updateGiftQuantity(giftBItem.key, 1);
        }

        // 满 499 元送 A，满 699 元送 B
        if (cartTotal >= 699) {
          if (giftAItem) await removeGift(giftAItem.key);
          if (!giftBItem) await addGift(GIFT_B_ID);
        } else if (cartTotal >= 499) {
          if (giftBItem) await removeGift(giftBItem.key);
          if (!giftAItem) await addGift(GIFT_A_ID);
        } else {
          if (giftAItem) {
            await removeGift(giftAItem.key);
          }
          if (giftBItem) {
            await removeGift(giftBItem.key);
          }
        }

      } catch (err) {
        console.error('❌ 满赠逻辑出错:', err);
      } finally {
        this.isLocked = false;
      }

    }
  };

  // 检查并应用赠品
  async function checkAndApplyGift(cart) {
    const cartTotal = cart.total_price / 100; // 转换为元
    const giftAItem = cart.items.find(item => item.variant_id === GIFT_A_ID);
    const giftBItem = cart.items.find(item => item.variant_id === GIFT_B_ID);

    console.log({ cart })

    // 修正赠品数量（限制每种赠品最多只能 1 个）
    if (giftAItem && giftAItem.quantity > 1) {
      updateGiftQuantity(giftAItem.key, 1);
    }
    if (giftBItem && giftBItem.quantity > 1) {
      updateGiftQuantity(giftBItem.key, 1);
    }

    // 满 499 元送 A，满 699 元送 B
    if (cartTotal >= 699) {
      if (giftAItem) await removeGift(giftAItem.key);
      if (!giftBItem) await addGift(GIFT_B_ID);
    } else if (cartTotal >= 499) {
      if (giftBItem) await removeGift(giftBItem.key);
      if (!giftAItem) await addGift(GIFT_A_ID);
    } else {
      if (giftAItem) {
        await removeGift(giftAItem.key);
      }
      if (giftBItem) {
        await removeGift(giftBItem.key);
      }
    }
  }

  // 添加赠品
  async function addGift(variantId) {
    console.log('addGift')
    const res = await postUrl(cartAddUrlAjax, {
      id: variantId,
      quantity: 1,
    });
    if (res && res.id) {
      const res = await getUrl(cartUrlAjax);
      if (res) updateCartUI(res);
    }
  }

  async function updateGiftQuantity(variantId, qty) {
    console.log('updateGiftQuantity')
    const res = await postUrl(cartChangeUrlAjax, {
      id: `${variantId}`,
      quantity: qty
    });
    if (res) updateCartUI(res);
  }

  // 移除赠品
  async function removeGift(variantId) {
    console.log('removeGift');
    const res = await postUrl(cartChangeUrlAjax, {
      id: `${variantId}`,
      quantity: 0
    });
    if (res) updateCartUI(res);
  }

  // 更新购物车界面
  function updateCartUI(cart) {
    console.log('updateCartUI');
    if (window.location.pathname === cartUrlAjax || document.querySelector('.cart')) {
      console.log('updatUrl')
      // cart页面手动刷新
      fetch(cartUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newCartItems = doc.querySelector('#main-cart');
          document.querySelector('#main-cart').innerHTML = newCartItems.innerHTML;
        });
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cart,
        }
      }));
    }
  }

  // 监听页面加载完成
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart(); // 页面加载时获取并检查购物车
  });

  document.addEventListener('cart:updated', async function (event) {
    console.log('cart:updated', Date.now());
    const detail = event.detail;
    if (detail && detail.cart) {
      GiftManager.checkAndApplyGift(detail.cart);
    }
  });


  // document.addEventListener('line-item-quantity:change:end', async function (event) {
  //   console.log('line-item-quantity:change:end');
  //   const cart = event.detail.cart;
  //   GiftManager.checkAndApplyGift(cart);
  // })

})() */

// video-list
// 参考product-list,有个限制css媒体查询不能灵活调整,只能为1000px
var VideoList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".video-list__scroller");
    this.videoItemList = this.querySelector(".video-list__item-list");
  }
  connectedCallback() {
    this.items = this.querySelectorAll("video-item");
    var isVideoPlayer = this.hasAttribute("is-video-player");
    if (isVideoPlayer) {
      this.localVideo = this.querySelector(".local-video");
      this.externalVideo = this.querySelector(".external-video");

      this.items.forEach((item, index) => {
        const aElement = item.querySelector("a");
        if (aElement) {
          const videoUrl =
            aElement.getAttribute("data-video") ||
            aElement.getAttribute("data-video-url");
          const videoType = aElement.getAttribute("data-video-type");
          if (index === 0) {
            this._switchVideoPlayer(videoUrl, videoType, true);
          }
          item.addEventListener("click", () => {
            this._switchVideoPlayer(videoUrl, videoType);
          });
        }
        // this._handleItem(item, false);
      });
      // 绑定搜索过滤
      this.delegate.on("click", ".custom-input-addon", () => {
        const searchEle = this.querySelector(".custom-input");
        this._searchVideoFront(searchEle.value);
      });
      this.delegate.on("keydown", ".custom-input", (event) => {
        if (event.key === "Enter") {
          this._searchVideoFront(event.target.value);
        }
      });
    } else {
      if (this.hasAttribute("scrollable")) {
        this.addEventListener("prev-next:prev", this.previous.bind(this));
        this.addEventListener("prev-next:next", this.next.bind(this));
        this.addEventListener("shopify:block:select", (event) =>
          event.target.scrollIntoView({
            block: "nearest",
            inline: "center",
            behavior: event.detail.load ? "auto" : "smooth",
          }),
        );
      }
    }

    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
  }

  _escapeRegExp(str) {
    return str
      .toLowerCase()
      .replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&")
      .replace(/\s+/g, " ")
      .trim(); // 转义所有正则表达式特殊字符
  }

  // 纯前端视频搜索
  _searchVideoFront(value) {
    const input = this._escapeRegExp(value);
    const self = this;
    this.items.forEach(function (item) {
      const titleEle = item.querySelector(".video-description");
      if (titleEle) {
        const title = self._escapeRegExp(titleEle.textContent);

        const isMatch = title.includes(input);

        const isItemHide = item.classList.contains("forced-to-hide");

        if (isMatch && isItemHide) {
          item.classList.remove("forced-to-hide");
        } else if (!isMatch && !isItemHide) {
          item.classList.add("forced-to-hide");
        }
      }
    });
  }

  // 检查浏览器是否支持指定的视频类型
  _isVideoTypeSupported(mimeType) {
    return this.localVideo.canPlayType(mimeType) !== "";
  }

  // 封装一个函数来动态设置视频源
  _setVideoSource(url, isInit) {
    const video = JSON.parse(url);
    // 创建一个 DocumentFragment，它不会立即被渲染到页面中
    const fragment = document.createDocumentFragment();
    if (video.sources.length > 0) {
      video.sources.forEach((item) => {
        const source = document.createElement("source"); // 创建 <li> 元素
        source.src = item.url;
        source.type = item.mime_type; // 设置列表项文本
        fragment.appendChild(source); // 将 <li> 添加到 fragment
      });
      this.localVideo.innerHTML = "";
      if (isInit) {
        this.localVideo.removeAttribute("autoplay");
      } else {
        this.localVideo.setAttribute("autoplay", true);
      }

      this.localVideo.appendChild(fragment);
      this.localVideo.load(); // 重新加载视频
      this.localVideo.style.display = "block";
    } else {
      this.localVideo.style.display = "none"; // 隐藏本地视频播放器
      console.error("Unsupported video");
    }
  }

  // 设置外部视频 (YouTube/Vimeo) 的 iframe 来源
  _setIframeSource(url, type, isInit) {
    if (type === "youtube") {
      this.externalVideo.src = `https://www.youtube.com/embed/${
        url.split("v=")[1]
      }?playsinline=1&autoplay=${
        isInit ? 0 : 1
      }&modestbranding=1&rel=0&origin=${encodeURI(
        `https://${window.themeVariables.routes.host}`,
      )}`;
    } else if (type === "vimeo") {
      this.externalVideo.src = `https://player.vimeo.com/video/${url
        .split("/")
        .pop()}?autoplay=1&autopause=1&transparent=0&responsive=1`;
    }
  }

  // 切换视频播放器（本地或外部视频）
  _switchVideoPlayer(url, type, isInit = false) {
    if (type === "youtube" || type === "vimeo") {
      this.localVideo.setAttribute("hidden", true);
      this.externalVideo.removeAttribute("hidden");
      this._setIframeSource(url, type, isInit);
    } else {
      this.localVideo.removeAttribute("hidden");
      this.externalVideo.setAttribute("hidden", true);
      this._setVideoSource(url, isInit);
    }
  }

  async _setupVisibility() {
    // 使用 IntersectionObserver 进行懒加载
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");

            // 停止观察当前元素
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    // 处理图片加载过程
    this.items.forEach((item) => {
      // 开始观察该 item
      observer.observe(item);
    });
  }
  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this.videoItemList).getPropertyValue("grid-gap"),
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0,
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this.videoItemList).getPropertyValue("grid-gap"),
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth,
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
};
window.customElements.define("video-list", VideoList);

var MultiLevelDesktopNavigation = class extends CustomHTMLElement {
  constructor() {
    super();
    this.cascadeTimeout = null; // 用于延迟级联展开，优化性能和视觉效果
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  connectedCallback() {
    // **事件绑定部分保持不变，它们是正确的**
    this.delegate.on(
      "click",
      ".header__linklist-item.has-dropdown",
      this.handleTopLevelClick.bind(this),
    );

    this.delegate.on(
      "click",
      ".nav-dropdown__item.has-dropdown > .nav-dropdown__link[aria-expanded]",
      (event, target) => {
        event.preventDefault();
        const parentElement = target.parentElement;
        const isExpanded = target.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
          // this.closeDropdown(parentElement);
        } else {
          this.openDropdown(parentElement);
        }
      },
    );
    this.delegate.on("shopify:block:select", (event) =>
      this.openDropdown(event.target.parentElement),
    );
    this.delegate.on("shopify:block:deselect", (event) =>
      this.closeAllDropdowns(),
    );
  }

  handleTopLevelClick(event, target) {
    const topLevelLink = target.querySelector(
      ":scope > a.header__linklist-link",
    );
    if (!topLevelLink) return;

    const clickedLink = event.target.closest("a.header__linklist-link");
    if (clickedLink !== topLevelLink) return;

    const isHashLink = topLevelLink.getAttribute("href") === "#";
    const isExpanded = topLevelLink.getAttribute("aria-expanded") === "true";

    if (isHashLink) {
      event.preventDefault();
      event.stopPropagation();
      if (isExpanded) {
        this.closeDropdown(target);
      } else {
        this.closeAllDropdowns();
        this.openDropdown(target, true);

        setTimeout(() => {
          document.addEventListener("click", this.handleDocumentClick);
        }, 0);
      }
    } else {
      this.closeAllDropdowns();
    }
  }

  handleDocumentClick(event) {
    const isClickInside = this.contains(event.target);
    const isMask = event.target?.classList?.contains?.("menu-mask");
    if (!isClickInside || isMask) {
      this.closeAllDropdowns();
      event.preventDefault();
    }
  }

  // **openDropdown 函数是本次改动的核心，逻辑被统一和强化**
  openDropdown(parentElement, isTopLevelLink) {
    if (!parentElement) return;
    const menuItem = parentElement.querySelector("[aria-controls]");
    if (!menuItem || menuItem.getAttribute("aria-expanded") === "true") return;

    const dropdown = document.querySelector(
      `#${menuItem.getAttribute("aria-controls")}`,
    );
    if (!dropdown) return;

    // 手风琴效果
    if (parentElement.parentElement) {
      const siblings = parentElement.parentElement.children;
      Array.from(siblings).forEach((sibling) => {
        if (
          sibling !== parentElement &&
          sibling.classList.contains("has-dropdown")
        ) {
          this.closeDropdown(sibling);
        }
      });
    }

    // 正常展开当前菜单
    let activedMenu = null;
    menuItem.setAttribute("aria-expanded", "true");
    dropdown.removeAttribute("hidden");
    // ----------- 统一的“深度展开”逻辑 -----------
    // **清除上一次可能存在的延迟任务，防止快速操作时出现混乱**
    clearTimeout(this.cascadeTimeout);

    this.cascadeTimeout = setTimeout(() => {
      let currentDropdown = dropdown;
      let cascadeCount = 0;
      const maxCascade = 5;

      // **使用循环来持续寻找并展开第一个子菜单，直到尽头**
      while (currentDropdown && cascadeCount < maxCascade) {
        const firstSubMenuItem = currentDropdown.querySelector(
          ".nav-dropdown__item.has-dropdown",
        )?.parentElement?.firstElementChild;

        if (
          firstSubMenuItem &&
          firstSubMenuItem.classList.contains("has-dropdown")
        ) {
          const nextMenuItem =
            firstSubMenuItem.querySelector("[aria-controls]");
          if (
            !nextMenuItem ||
            nextMenuItem.getAttribute("aria-expanded") === "true"
          )
            break; // 如果找不到链接或已展开，则停止

          const nextDropdown = document.querySelector(
            `#${nextMenuItem.getAttribute("aria-controls")}`,
          );
          if (nextDropdown) {
            nextMenuItem.setAttribute("aria-expanded", "true");
            activedMenu = nextMenuItem;
            nextDropdown.removeAttribute("hidden");
            currentDropdown = nextDropdown; // 更新当前面板，以便在下一次循环中继续向深层寻找
          } else {
            break;
          }
        } else {
          break;
        }
        cascadeCount++;
      }

      if (!activedMenu && !isTopLevelLink) {
        activedMenu = menuItem;
      }
      activedMenu.classList.add("actived-menu");
      // 动态插入mega-menu-content
      const megaMenuContent = this.querySelector(
        `#${activedMenu.getAttribute("aria-controls")}:not([has_append])`,
      );
      if (megaMenuContent) {
        const template = megaMenuContent.querySelector("template");
        if (template) {
          const fragment = template.content.cloneNode(true);
          megaMenuContent.appendChild(fragment);
          megaMenuContent.setAttribute("has_append", true);

          const megaMenuContainer = this.querySelector(".right");
          if (megaMenuContainer) {
            megaMenuContainer.appendChild(fragment);
          }
        }
      }
    }, 50); // 确保DOM更新完成
  }


  closeDropdown(parentElement) {
    if (!parentElement || !parentElement.classList.contains("has-dropdown"))
      return;
    const menuItem = parentElement.querySelector("[aria-controls]");
    if (!menuItem || menuItem.getAttribute("aria-expanded") === "false") return;

    parentElement.querySelectorAll(".has-dropdown").forEach((childDropdown) => {
      if (childDropdown !== parentElement) {
        this.closeDropdown(childDropdown);
      }
    });

    menuItem.setAttribute("aria-expanded", "false");

    if (menuItem.classList.contains("actived-menu")) {
      menuItem.classList.remove("actived-menu");
    }
    const dropdown = document.querySelector(
      `#${menuItem.getAttribute("aria-controls")}`,
    );
    if (dropdown) {
      dropdown.setAttribute("hidden", "");
    }
  }

  closeAllDropdowns() {
    this.querySelectorAll(".has-dropdown").forEach((item) => {
      this.closeDropdown(item);
    });
    clearTimeout(this.cascadeTimeout); // 离开时清除所有延迟任务
    document.removeEventListener("click", this.handleDocumentClick);
  }
};
window.customElements.define(
  "multi-level-desktop-navigation",
  MultiLevelDesktopNavigation,
);

// js/custom-element/behavior/collapsible-content.js
var DynamicallyCollapsibleContent = class extends OpenableElement {
  constructor() {
    super();
    this.ignoreNextTransition = this.open;
    this.addEventListener("shopify:block:select", () => (this.open = true));
    this.addEventListener("shopify:block:deselect", () => (this.open = false));
  }
  get animateItems() {
    return this.hasAttribute("animate-items");
  }
  attributeChangedCallback(name) {
    if (this.ignoreNextTransition) {
      return (this.ignoreNextTransition = false);
    }
    switch (name) {
      case "open":
        // 动态插入
        const hasAppend = this.getAttribute("has_append");
        if (!hasAppend) {
          const template = this.querySelector("template");
          if (template) {
            const fragment = template.content.cloneNode(true);
            this.innerHTML = "";
            this.appendChild(fragment);
            this.setAttribute("has_append", true);
          }
        }

        this.style.overflow = "hidden";
        const keyframes = {
          height: ["0px", `${this.scrollHeight}px`],
          visibility: ["hidden", "visible"],
        };
        if (this.animateItems) {
          keyframes["opacity"] = this.open ? [0, 0] : [0, 1];
        }
        this.animate(keyframes, {
          duration: 500,
          direction: this.open ? "normal" : "reverse",
          easing: "cubic-bezier(0.75, 0, 0.175, 1)",
        }).onfinish = () => {
          this.style.overflow = this.open ? "visible" : "hidden";
        };
        if (this.animateItems && this.open) {
          this.animate(
            {
              opacity: [0, 1],
              transform: ["translateY(10px)", "translateY(0)"],
            },
            {
              duration: 250,
              delay: 250,
              easing: "cubic-bezier(0.75, 0, 0.175, 1)",
            },
          );
        }
        triggerEvent(
          this,
          this.open ? "openable-element:open" : "openable-element:close",
        );
    }
  }
};
window.customElements.define(
  "dynamically-collapsible-content",
  DynamicallyCollapsibleContent,
);

// menu 产品画廊
class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false; // 添加一个状态，防止重复初始化
  }

  connectedCallback() {
    // 找到要监视的目标：父容器
    const megaMenuContainer = this.closest(".new-mega-menu");
    if (megaMenuContainer) {
      // 创建一个MutationObserver哨兵
      const observer = new MutationObserver((mutations) => {
        const isHidden = megaMenuContainer.hasAttribute("hidden");
        // 第一次从隐藏变为可见 -> 初始化
        if (!isHidden && !this.isInitialized) {
          this.initialize();
        } else if (isHidden && this.isInitialized) {
          // 已经初始化过，且变回隐藏 -> 重置状态
          this.resetState();
        }
      }); // 命令哨兵开始监视父容器的属性变化
      observer.observe(megaMenuContainer, { attributes: true });
      if (!megaMenuContainer.hasAttribute("hidden")) {
        this.initialize();
      }
    } else {
      requestAnimationFrame(() => this.initialize());
    }
  }

  resetState() {
    if (!this.isInitialized) return;

    this.currentIndex = 0;
    requestAnimationFrame(() => this.moveToIndex(0));
  }

  initialize() {
    this.isInitialized = true;

    this.productList = this.querySelector(".product-carousel__list");
    this.prevButton = this.querySelector(".product-carousel__button--prev");
    this.nextButton = this.querySelector(".product-carousel__button--next");
    this.wrapper = this.querySelector(".product-carousel__wrapper");

    this.productItems = this.querySelectorAll(".product-carousel__item");
    if (this.productItems.length === 0) {
      return;
    }

    this.currentIndex = 0;
    this.updateButtons = this.updateButtons.bind(this);

    this.prevButton.addEventListener("click", this.handlePrevClick.bind(this));
    this.nextButton.addEventListener("click", this.handleNextClick.bind(this));

    this.resizeObserver = new ResizeObserver(this.updateButtons);
    this.resizeObserver.observe(this.wrapper);

    this.updateButtons();
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  handlePrevClick() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.moveToIndex(this.currentIndex);
    }
  }

  handleNextClick() {
    if (!this.nextButton.hasAttribute("disabled")) {
      this.currentIndex++;
      this.moveToIndex(this.currentIndex);
    }
  }

  moveToIndex(index) {
    const itemWidth = this.productItems[0].offsetWidth;
    const gap =
      parseInt(window.getComputedStyle(this.productList).gap, 10) || 20;
    const scrollAmount = itemWidth + gap;
    const newTransformValue = -index * scrollAmount;

    this.productList.style.transform = `translateX(${newTransformValue}px)`;
    this.updateButtons();
  }

  updateButtons() {
    if (!this.isInitialized) return; // 安全检查

    this.prevButton.toggleAttribute("disabled", this.currentIndex === 0);

    const wrapperWidth = this.wrapper.offsetWidth;
    const totalItemsWidth = this.productList.scrollWidth;
    // 如果宽度为0（例如元素依然隐藏），则暂时禁用next按钮
    if (wrapperWidth === 0) {
      this.nextButton.toggleAttribute("disabled", true);
      return;
    }

    const currentTranslateX = Math.abs(
      parseFloat(this.productList.style.transform.replace("translateX(", "")) ||
        0,
    );

    const isAtEnd = currentTranslateX + wrapperWidth + 5 >= totalItemsWidth;
    this.nextButton.toggleAttribute(
      "disabled",
      isAtEnd || totalItemsWidth <= wrapperWidth,
    );
  }
}

window.customElements.define("product-carousel", ProductCarousel);

const JdgmQaCounter = class extends HTMLElement {
  connectedCallback() {
    const template = this.querySelector("template");
    if (!template) return;

    const content = template.content;
    const badge = content.querySelector(
      ".jdgm-preview-badge, [data-number-of-questions]",
    );

    if (badge) {
      const count =
        badge.dataset.numberOfQuestions > 0
          ? badge.dataset.numberOfQuestions
          : undefined;

      const displayTemplate = this.getAttribute("data-template") || "%count%";
      const countWrapper = this.querySelector(".count-label");
      countWrapper.innerHTML = count
        ? displayTemplate.replace("%count%", count)
        : this.getAttribute("data-empty");

      this.setAttribute("resolved", "");
    }
  }
};
window.customElements.define("jdgm-qa-counter", JdgmQaCounter);

var _NewCartDrawerRecommendations = class _NewCartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    // 1. 将所有事件处理函数绑定 this，确保引用唯一，避免内存泄漏
    this.init = this.init.bind(this);
    this._onOpen = this._onOpen.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onCartUpdated = this._onCartUpdated.bind(this);
  }

  connectedCallback() {
    // 兼容查找：可能是 .mini-cart，也可能直接是 cart-drawer 标签本身
    this._openElement =
      this.closest(".mini-cart") || this.closest("cart-drawer");
    if (!this._openElement) return;

    this._openElement.addEventListener("openable-element:open", this._onOpen);
    this._openElement.addEventListener("openable-element:close", this._onClose);

    // 🔥 核心修复：防止 DOM 被 cart-drawer 替换后，组件挂载时处于“发呆”状态。
    // 如果挂载时，抽屉本来就是开着的，直接手动触发 _onOpen
    if (
      this._openElement.open ||
      this._openElement.hasAttribute("open") ||
      this._openElement.classList.contains("is-open")
    ) {
      this._onOpen();
    }
  }

  disconnectedCallback() {
    if (!this._openElement) return;

    // 修复拼写错误：_onOpe -> _onOpen
    this._openElement.removeEventListener(
      "openable-element:open",
      this._onOpen,
    );
    this._openElement.removeEventListener(
      "openable-element:close",
      this._onClose,
    );

    // 清理全局事件
    document.documentElement.removeEventListener(
      "cart:updated",
      this._onCartUpdated,
    );
  }

  _onOpen() {
    this.init(); // 打开时立刻请求/渲染一次

    // 绑定具体的函数引用，而不是匿名函数
    document.documentElement.addEventListener(
      "cart:updated",
      this._onCartUpdated,
    );
  }

  _onClose() {
    // 正确移除绑定的函数
    document.documentElement.removeEventListener(
      "cart:updated",
      this._onCartUpdated,
    );
  }

  // 提取出原本的匿名函数逻辑
  _onCartUpdated(event) {
    const firstNonzeroItemId = (event?.detail?.cart?.items || []).filter(
      (x) => x.final_line_price > 0,
    )[0]?.product_id;

    if (firstNonzeroItemId) {
      this.init(firstNonzeroItemId);
    } else {
      this.init();
    }
  }

  async init(productId) {
    const newProductId = productId || this.productId;
    if (!newProductId) return;

    if (!_NewCartDrawerRecommendations.recommendationsCache[newProductId]) {
      _NewCartDrawerRecommendations.recommendationsCache[newProductId] = fetch(
        `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${newProductId}&limit=10&section_id=${this.sectionId}`,
      );
    }

    try {
      const response =
        await _NewCartDrawerRecommendations.recommendationsCache[newProductId];
      const div = document.createElement("div");
      div.innerHTML = await response.clone().text();
      const productRecommendationsElement = div.querySelector(
        "new-cart-drawer-recommendations",
      );

      // 🔥 核心防御机制：
      // 如果此时 fetch 刚刚返回，但这个组件已经被 <cart-drawer> 的 setTimeout 给移除了
      // 就不要再做无用的赋值了，直接 return，避免报错。新的组件会接管渲染。
      if (!this.isConnected) return;

      if (
        productRecommendationsElement &&
        productRecommendationsElement.hasChildNodes()
      ) {
        this.innerHTML = productRecommendationsElement.innerHTML;
        this.hidden = false;
      } else {
        this.innerHTML = "";
        this.hidden = true;
      }
    } catch (error) {
      console.error("Failed to load recommendations:", error);
    }
  }

  get productId() {
    return this.getAttribute("product-id");
  }

  get sectionId() {
    return this.getAttribute("section-id");
  }
};

__publicField(_NewCartDrawerRecommendations, "recommendationsCache", {});
var NewCartDrawerRecommendations = _NewCartDrawerRecommendations;
window.customElements.define(
  "new-cart-drawer-recommendations",
  NewCartDrawerRecommendations,
);

class FlipCountdown extends HTMLElement {
  constructor() {
    super();
    this.animationFrameId = null;
    this.previousTime = {};
    this.loop = this.loop.bind(this);
    this.timeOffset = 0;
    this.hasInitialized = false;
  }

  async connectedCallback() {
    this.initDOM();
    await this.fetchServerTime();
    this.initFromAttributes();
    this.hasInitialized = true;
  }

  disconnectedCallback() {
    this.stop();
  }

  initDOM() {
    this.flipperElements = this.querySelectorAll("[data-flipper]");
    this.wrapperBar = this.querySelector(".tp-countdown-container-bar-wrapper");
    this.dayBlock = this.querySelector("#days-block");
    this.hourBlock = this.querySelector("#hours-block");
  }

  async fetchServerTime() {
    try {
      const response = await fetch(`/cart.js?t=${new Date().getTime()}`, {
        method: "HEAD",
      });
      const dateHeader = response.headers.get("Date");
      this.dataset.serverTime = dateHeader
        ? new Date(dateHeader).toISOString()
        : new Date().toISOString();
    } catch (error) {
      this.dataset.serverTime = new Date().toISOString();
    }
  }

  parseDate(dateStr) {
    if (!dateStr || dateStr.trim() === "") return null;
    let safeStr = dateStr.trim().replace(/\//g, "-").replace(" ", "T");
    if (safeStr.length === 16) safeStr += ":00";
    return new Date(safeStr);
  }

  initFromAttributes() {
    const startTs = parseInt(this.dataset.startTimestamp, 10);
    let startTime =
      startTs > 0
        ? new Date(startTs * 1000)
        : this.parseDate(this.dataset.startTime);

    const endTs = parseInt(this.dataset.endTimestamp, 10);
    let endTime =
      endTs > 0 ? new Date(endTs * 1000) : this.parseDate(this.dataset.endTime);

    const serverTime = new Date(this.dataset.serverTime || new Date());

    if (!endTime || isNaN(endTime.getTime())) {
      this.classList.remove("is-active");
      return;
    }

    this.timeOffset = serverTime.getTime() - new Date().getTime();
    const now = this.getCurrentTime();

    // UE：自动展示逻辑
    if (startTime && now < startTime) {
      this.stop();
      this.classList.remove("is-active"); // 未到时间，隐藏

      // 精准埋下定时器，时间一到自动执行显示逻辑
      const delay = startTime.getTime() - now.getTime();
      this.timeoutId = setTimeout(() => {
        this.initFromAttributes();
      }, delay);
    } else if (now >= startTime && now < endTime) {
      this.targetDate = endTime;
      this.classList.add("is-active"); // 到达时间，添加动画展示
      this.start();
    } else {
      this.stop();
      this.classList.remove("is-active"); // 结束，隐藏
    }
  }

  getCurrentTime() {
    return new Date(new Date().getTime() + this.timeOffset);
  }

  start() {
    this.stop();
    this.previousTime = undefined;
    this.loop();
  }

  stop() {
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.animationFrameId = null;
    this.timeoutId = null;
  }

  loop() {
    const now = this.getCurrentTime();
    const timeRemaining = this.targetDate - now;
    this.updateTimeDisplay(timeRemaining);
    if (timeRemaining > 0) {
      this.animationFrameId = requestAnimationFrame(this.loop);
    } else {
      this.stop();
      this.classList.remove("is-active"); // 倒计时归零，自动消失
    }
  }

  updateTimeDisplay(timeRemaining) {
    if (timeRemaining <= 0) timeRemaining = 0;

    const s = String(Math.floor((timeRemaining / 1000) % 60)).padStart(2, "0");
    const m = String(Math.floor((timeRemaining / 1000 / 60) % 60)).padStart(
      2,
      "0",
    );
    const hStr = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    const d = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    // UE 优化：小于1天折叠 Day，小于1小时折叠 Hour
    if (this.dayBlock) {
      this.dayBlock.classList.toggle("is-hidden", d < 1);
    }
    if (this.hourBlock) {
      this.hourBlock.classList.toggle("is-hidden", d < 1 && hStr < 1);
    }

    // UE 冲刺模式：小于1天背景渐变红色警告
    if (this.wrapperBar) {
      this.wrapperBar.classList.toggle("is-urgent", d < 2);
    }

    const dStr = String(d).padStart(2, "0");
    const hFormatted = String(hStr).padStart(2, "0");
    const isFirstRun = this.previousTime === undefined;

    this.updateAllCards(dStr, hFormatted, m, s, isFirstRun);

    if (isFirstRun) this.previousTime = {};
  }

  updateAllCards(d, h, m, s, isFirstRun) {
    if (!this.flipperElements || this.flipperElements.length < 8) return;
    if (this.previousTime?.days !== d) {
      this.flipDigit(this.flipperElements[0], d[0], isFirstRun);
      this.flipDigit(this.flipperElements[1], d[1], isFirstRun);
    }
    if (this.previousTime?.hours !== h) {
      this.flipDigit(this.flipperElements[2], h[0], isFirstRun);
      this.flipDigit(this.flipperElements[3], h[1], isFirstRun);
    }
    if (this.previousTime?.minutes !== m) {
      this.flipDigit(this.flipperElements[4], m[0], isFirstRun);
      this.flipDigit(this.flipperElements[5], m[1], isFirstRun);
    }
    if (this.previousTime?.seconds !== s) {
      this.flipDigit(this.flipperElements[6], s[0], isFirstRun);
      this.flipDigit(this.flipperElements[7], s[1], isFirstRun);
    }
    this.previousTime = { days: d, hours: h, minutes: m, seconds: s };
  }

  flipDigit(flipCard, newDigit, isFirstRun) {
    if (!flipCard) return;
    if (isFirstRun) {
      flipCard
        .querySelectorAll(".tp-top, .tp-bottom, .tp-top-flip, .tp-bottom-flip")
        .forEach((el) => (el.textContent = newDigit));
      return;
    }
    const top = flipCard.querySelector(".tp-top");
    const bottom = flipCard.querySelector(".tp-bottom");
    const topFlip = flipCard.querySelector(".tp-top-flip");
    const bottomFlip = flipCard.querySelector(".tp-bottom-flip");

    const currentDigit = bottom.textContent;
    if (currentDigit === newDigit || flipCard.classList.contains("flipping"))
      return;

    top.textContent = newDigit;
    bottomFlip.textContent = newDigit;
    topFlip.textContent = currentDigit;

    requestAnimationFrame(() => flipCard.classList.add("flipping"));

    bottomFlip.addEventListener(
      "animationend",
      () => {
        bottom.textContent = newDigit;
        topFlip.textContent = newDigit;
        flipCard.classList.remove("flipping");
      },
      { once: true },
    );
  }
}
window.customElements.define("flip-countdown", FlipCountdown);
